export default "__VITE_ASSET__F2gAuJ9f__"